import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { HttpService } from "./http.service";

const basePath = "/ImportationLog";
const request = HttpService.handleRequest();

export const ImportationLogService = {
  getPaginatedList
};

async function getListByImportation(id) {
  return request.get(`${basePath}/GetByImportationId/${id}`);
}

async function getPaginatedList(data: RequestInputOutputParamsModel) {
  return request.post(`${basePath}/ListWithPagination`, data);
}

export default ImportationLogService;